import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { GenericListComponent, Page, HasAction, Actions } from '../../shared-components/generic-list/generic-list.component';
import { SecurityService } from '../../security/security.service';
import { Sector } from './sector.model';


interface Filters {
  description: string;
  page: number;
  size: number;
  search?: string;
}

@Component({
  selector: 'app-sector-list',
  templateUrl: './sector-list.component.html',
  styleUrls: ['./sector-list.component.scss']
})
@Injectable()
export class SectorListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private backendUrl: string;

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
  };

  columns = [
    { name: 'description',  label: 'Descripcion' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  public hasActions: HasAction;

  sectorFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  sectorList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const sectorPromise = this.backendService.get(Sector, Sector.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const sector = await sectorPromise;
        return sector;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.sectorFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Sector[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) {
    this.backendUrl = env.endpoints.api+'/backend';
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_MOTIVOS_RECHAZO'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_MOTIVOS_RECHAZO'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.sectorList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshSectorList();
  }


  refreshSectorList() {
    this.sectorList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshSectorList();
  }

  onSearch(searchText) {
    this.filters.search = 'description:' + searchText;
    this.refreshSectorList();
  }

  clearSearch() {
      this.refreshSectorList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAddSector() {
    this.router.navigate(['/sectores/agregar']);
  }


  onEditSector(role: Sector) {
    this.router.navigate(['/sectores/editar', role.id]);
  }


  async onDeleteSector(sector: Sector) {

    this.dialogService.confirm('Eliminar sector comercial',
    '¿Está seguro que desea eliminar los sectores comerciales ' + sector.description + '?')
    .then( res => {
      if (res) {
        this.deleteSector(res, sector);
      }
    });

  }

  async deleteSector(res, sector: Sector) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Sector.path + sector.id);
        this.snackService.success('Motivos de rechazo eliminados correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshSectorList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshSectorList();
  }

  removeChip(event) {
    this.refreshSectorList();
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/sectores/sector-list.component.ts